/**
 * Feature preferences hooks using TanStack Query
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { featureApi } from '../api/featureApi';
import type { ConfigurableFeature } from '../schemas/feature.schemas';

const FEATURES_QUERY_KEY = ['feature-preferences'];

/**
 * Hook to fetch configurable feature preferences
 */
export function useFeaturePreferences() {
  return useQuery<ConfigurableFeature[]>({
    queryKey: FEATURES_QUERY_KEY,
    queryFn: featureApi.getPreferences,
  });
}

/**
 * Hook to update a feature's preferences
 */
export function useUpdateFeaturePreference() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      featureId,
      options,
    }: {
      featureId: string;
      options: Record<string, unknown>;
    }) => featureApi.updatePreference(featureId, options),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: FEATURES_QUERY_KEY });
    },
  });
}
